import { render, staticRenderFns } from "./am.vue?vue&type=template&id=048712f5&scoped=true&"
import script from "./am.vue?vue&type=script&lang=js&"
export * from "./am.vue?vue&type=script&lang=js&"
import style0 from "./am.vue?vue&type=style&index=0&id=048712f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048712f5",
  null
  
)

export default component.exports